<Section>
  <!-- this is for Grid Table  manageAttributeGrid-->
  <!-- #manageAttributeGrid must be Unique-->
  <kendo-grid #manageAttributeGrid [data]="manageAttributeGridView" [height]="410" [sortable]="true" [navigable]="true"
    [filterable]="true" [groupable]="false" [reorderable]="true" [resizable]="false" [columnMenu]="false"
    [pageSize]="gridState.take" [skip]="gridState.skip" (sortChange)="attributeGridSortChange($event)"
    [pageable]="{ buttonCount: 5, info: true }" [sort]="gridState.sort" [filter]="gridState.filter"
    (pageChange)="attributeGridPageChange($event)" (dataStateChange)="gridDataStateChange($event)"
    [loading]="manageAttribute.grid.loading">


    <kendo-grid-column field="attributeId" title="Attribute ID #" [columnMenu]="false" [filterable]="true"
      [editable]="false" [width]="100">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="attributeName" title="Attribute Name" [columnMenu]="false" [filterable]="true"
      [editable]="false" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>



    <kendo-grid-column field="v6OptionCode" title="v6 Reference Code" [columnMenu]="false" [filterable]="true"
      [editable]="false" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="publishedName" title="Published Name" [columnMenu]="false" [filterable]="true"
      [editable]="false" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="attributeValueTypeName" title="Type" [columnMenu]="false" [filterable]="true"
      [editable]="false" [width]="120">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="isActive" title="Active" [columnMenu]="false" [filterable]="false" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <kendo-switch name="isActive" [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true" [offLabel]="'No'">
        </kendo-switch>
      </ng-template>

    </kendo-grid-column>

    <kendo-grid-command-column title="Selection" [width]="100" field="selection" [style]="{'text-align': 'center'}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton [icon]="'edit'" class="m-2 clearKendoButton btn btn-success btnSizeCls"
                (click)="toggleAttributeEditDialog('Edit',dataItem)">
        </button>
        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>
      </ng-template>
    </kendo-grid-command-column>
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="manageAttribute.grid.buttonCount"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="manageAttribute.grid.pageSizes"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <button (click)="toggleAttributeEditDialog('Add',{})" [icon]="'plus'" class="m-3 clearKendoButton btn btn-success"
      kendoButton>
      Add Attribute
    </button>

  </div>
</Section>

<Section class="dialogSection">
  <!-- this is for Edit Dialog  -->
  <kendo-dialog title="{{actionType}} Attribute" *ngIf="attributeEditDialog.opened"
    (close)="toggleAttributeEditDialog()" class="attributeDialogCls">
    <div class="container-fluid">

      <form [formGroup]="attributeForm" style="max-height: 400px">
        <div class="form-row">
          <input type="hidden" formControlName="attributeId" />
          <div class="form-group col-md-12">
            <label class="lblCls">{{attributeEditDialog.nameLbl}}</label>
            <div class="form-inline">
              <input type="text" kendoTextBox class="form-control" name="attributeName"
                     (blur)="attributeNameShouldbeUnique()"
                     [ngClass]="{'borderRed':attributeEditDialog.isInvalidAttributeName && attributeEditDialog.isSubmitted}"
                     formControlName="attributeName" />
              <span title="{{attributeNameInfo}}"
                    *ngIf="attributeEditDialog.isInvalidAttributeNameMessge && attributeEditDialog.isSubmitted" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">
              {{attributeEditDialog.publishedNameLbl}}
            </label>
            <input type="text" kendoTextBox class="form-control" name="publishedName"
                   [ngClass]="{'borderRed':attributeEditDialog.isInvalidPublishedName && attributeEditDialog.isSubmitted}"
                   (blur)="validateAttributeForm()" formControlName="publishedName" />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12">
            <label class="lblCls">
              {{attributeEditDialog.v6ReferenceCodeLbl}}
            </label>
            <input type="text" kendoTextBox class="form-control" name="v6OptionCode"
                   [ngClass]="{'borderRed':attributeEditDialog.isInvalidV6OptionCode && attributeEditDialog.isSubmitted}"
                   (blur)="validateAttributeForm()" formControlName="v6OptionCode" />
          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">
              {{attributeEditDialog.typeLbl}}
            </label>
            <kendo-dropdownlist [data]="attributeEditDialog.typeData" kendoTextBox formControlName="attributeValueTypeId"
                                textField="name" valueField="value" (valueChange)="attributeEditDialogSelected($event)"
                                [ngClass]="{'borderRed':attributeEditDialog.isInvalidAttributeValueTypeId && attributeEditDialog.isSubmitted}"
                                (blur)="validateAttributeForm()" [valuePrimitive]="true" [loading]="attributeEditDialog.typeDataLoading"
                                class="kendoInput">
            </kendo-dropdownlist>

          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">
              {{attributeEditDialog.active}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          [ngClass]="{'borderRed':attributeEditDialog.isInvalidIsActive && attributeEditDialog.isSubmitted}"
                          (blur)="validateAttributeForm()" class="activeSwitchCls">
            </kendo-switch>
          </div>

          <div formArrayName="attributeValues" *ngFor="let a of attributeForm.get('attributeValues').controls; let i = index">
            <div [formGroupName]="i" style="margin-bottom: 10px;">

              <div class="col-md-12">
                <div class="form-group attribute-container">
                  <ul id="ctnAttributeListItems" class="ui-sortable">
                    <li class="attribute-value-item" data-index="0">
                      <table>
                        <tbody>
                          <tr>
                            <td class="handle" rowspan="3">
                              <!--  Sort<span class="jq-sort-handle typcn typcn-arrow-unsorted"></span>-->
                              <input name="displaySequence" formControlName="attributeValueName" type="hidden" [value]="i">
                            </td>
                            <td class="name">
                              <div class="input-group">
                                <span class="input-group-addon">Name</span>
                                <input name="attributeValueName" formControlName="attributeValueName" class="form-control" type="text">
                              </div>
                            </td>
                            <td class="code">
                              <div class="input-group">
                                <span class="input-group-addon">Code</span>
                                <input name="v6Code" formControlName="v6Code" class="form-control" type="text">
                              </div>
                            </td>
                            <td rowspan="3" class="remove">
                              <button (click)="deleteItem(i)" class="k-button k-grid-remove-command ">
                                <span class="k-icon k-i-trash">
                                </span>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="code" colspan="2">
                              <div class="input-group">
                                <span class="input-group-addon">V6 Reference Code</span>
                                <input name="v6OptionCode" formControlName="v6OptionCode" class="form-control" type="text">
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" class="desc">
                              <div class="input-group">
                                <span class="input-group-addon">Description</span>
                                <input name="attributeValueDescription" formControlName="attributeValueDescription" class="form-control" type="text">
                                <button *ngIf="i > 0" class="k-i-arrow-chevron-right k-icon-size form-control"
                                        (click)="moveAttributeValue(i, 'up')"
                                        style="color: black; height: 40px; font-size: 20px"
                                        aria-label="Up"
                                        >

                                  <!-- Up Arrow -->
                                </button>
                                <button formArrayName="attributeValues" *ngIf=" i < attributeForm.get('attributeValues').controls.length - 1" class="k-i-arrow-chevron-down k-icon-size form-control"
                                        (click)="moveAttributeValue(i, 'down')"
                                        style="color: black; height: 40px; font-size:20px"
                                        aria-label="Down"
                                        >

                                  <!--Down Arrow-->
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>


          <div class="row col-md-12">
            <div class="form-group">
              <div class="col-lg-4"></div>
              <div class="col-lg-3" id="divAddValue">
                <button type="button" kendoButton (click)="addItem()"
                        class="attributeDialogCls" id="btnAddAttributeListItem">
                  <span class="glyphicon glyphicon-plus"></span>
                  Add Value
                </button>
              </div>
              <div></div>
            </div>
          </div>
        </div>

        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button (click)="toggleAttributeEditDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton>
                  Close
                </button> &nbsp;&nbsp;
                <button (click)="saveAttributeData()" class="m-3 btn btn-success dialogBtnSize" kendoButton
                        [disabled]="saveInProcess">
                  Save<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </kendo-dialog>

</Section>

<!--<section>-->
  <!--<iframe></iframe>-->
  <!--<iframe src='https://view.officeapps.live.com/op/embed.aspx?src=http://www.learningaboutelectronics.com/Articles/Example.xlsx' width='100%' height='565px' frameborder='0'> </iframe>-->
  <!--<iframe src='https://view.officeapps.live.com/op/embed.aspx?src=https://arconic-my.sharepoint.com/:x:/r/personal/v-maitiu_arconic_com/Documents/KNAPB2.xlsx?d=w618ed5eb941343c7a65408621ef6bfd2&csf=1&web=1&e=unBscP' width='100%' height='565px' frameborder='0'> </iframe>-->
  <!--<iframe src="https://www.w3schools.com" title="W3Schools Free Online Web Tutorials"></iframe>-->
  <!--<iframe name="WebApplicationFrame" id="WebApplicationFrame" src="https://view.officeapps.live.com/op/embed.aspx?src=https://arconic-my.sharepoint.com/:x:/r/personal/v-maitiu_arconic_com/Documents/KNAPB2.xlsx?d=w618ed5eb941343c7a65408621ef6bfd2&csf=1&web=1&e=unBscP" title="Office Online Frame" width="100%" height="100%" marginwidth="0" marginheight="0" frameborder="0" allowfullscreen="true" allowtransparency="true" allow="microphone https://excel.officeapps.live.com; camera https://excel.officeapps.live.com;" style="inset: 0px; display: block; position: absolute; background-color: transparent; border: none;">
  </iframe>-->
<!--</section>-->

<!--<section>
  <div class="attributeValue row">
    <table class="table col-4">
     
      <tbody>
        <tr>
          <th scope="row" rowspan="3">
            <button class="k-button k-grid-remove-command ">
              <span class="k-icon k-i-trash">
              </span>
            </button>
          </th>
          <td>
            <div class="form-group">
              <div class="input-group m-0">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">@</span>
                  <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="form-group">
              <div class="input-group m-0">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">@</span>
                  <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </div>
            </div>
          </td>
          <th scope="row" rowspan="3">
            <button class="k-button k-grid-remove-command ">
              <span class="k-icon k-i-trash">
              </span>
            </button>
          </th>
        </tr>
        <tr>
          <td>
            <div class="form-group">
              <div class="input-group m-0">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">@</span>
                  <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="form-group">
              <div class="input-group m-0">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">@</span>
                  <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>-->
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.attributeName }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
